import { render, staticRenderFns } from "./RestrictedFeatures.vue?vue&type=template&id=384e6c9a"
import script from "./RestrictedFeatures.vue?vue&type=script&lang=js"
export * from "./RestrictedFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports